import { useQuery } from '@tanstack/react-query';
import { api, GameStateResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseGameStatesReturn {
  states: GameStateResponse[];
  total: number;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useGameStates(): UseGameStatesReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.gameState.list(),
    queryFn: () => api.listGameStates({ limit: 100 }),
  });

  return {
    states: data?.states ?? [],
    total: data?.total ?? 0,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load game states' : null,
    refresh: () => {
      refetch();
    },
  };
}
